import React from 'react';

export default function ImplBlock1_5Institutional() {
  return (
    <section className="py-24 bg-surface border-b border-line">
      <div className="max-w-[1280px] mx-auto px-6 md:px-16 flex flex-col md:flex-row gap-16 lg:gap-24 items-start">
        
        <div className="w-full md:w-1/2 flex flex-col items-start text-left">
          <div className="text-[14px] font-semibold text-ink-soft/70 mb-6">
            Alineamiento institucional
          </div>
          <h2 className="text-[28px] md:text-[36px] lg:text-[40px] font-bold text-ink mb-6 tracking-tight">
            Alineado con la operación de APS chilena.
          </h2>
          <p className="text-[18px] md:text-[20px] text-ink-soft leading-[1.6]">
            BAC no crea nuevas metas para APS ni redefine sus funciones. Ayuda a operar de manera escalable las responsabilidades que la red ya tiene. Sobre las reglas y modelos de atención acordados, BAC identifica brechas, prioriza población, conecta necesidades con capacidad disponible y mantiene trazabilidad de lo que ocurrió y qué sigue.
          </p>
        </div>

        <div className="w-full md:w-1/2 flex flex-col justify-center h-full">
          <div className="bg-paper p-10 rounded-xl border border-line flex flex-col items-center text-center">
            <h3 className="text-[20px] font-bold text-ink mb-8">
              Apoyo directo al cumplimiento
            </h3>
            
            <div className="flex flex-col sm:flex-row items-center justify-center gap-6 w-full mb-12">
              <span className="text-[14px] font-bold text-ink tracking-widest uppercase">MAIS</span>
              <span className="hidden sm:block text-ink-soft/30">|</span>
              <span className="text-[14px] font-bold text-ink tracking-widest uppercase">ECICEP</span>
              <span className="hidden sm:block text-ink-soft/30">|</span>
              <span className="text-[14px] font-bold text-ink tracking-widest uppercase">IAAPS</span>
            </div>

            <p className="text-[14px] text-ink-soft leading-relaxed">
              BAC apoya la operacionalización de necesidades y acuerdos de cuidado bajo los modelos MAIS / ECICEP, y ayuda a identificar población y acciones que contribuyen operacionalmente al cumplimiento IAAPS.
            </p>
          </div>
        </div>
        
      </div>
    </section>
  );
}
